import React from 'react';
import PropTypes from 'prop-types';
import { Formik, ErrorMessage } from 'formik';

import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import { SendInboundsFormValidationSchema } from 'scenes/Form/components/SendInboundsForm/validate';
import BasicTextArea from 'components/BasicTextArea';
import AsyncAutosuggest from 'components/AsyncAutosuggest';
import BasicButton from 'components/BasicButton';
import LoadMask from 'components/LoadMask';

import { useApi } from 'hooks/useApi';
import { ENDPOINT } from 'constants/endpoints';

import { CSSTransition } from 'react-transition-group';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import './styles.css';

const SendInboundsForm = props => {
  const { onSaveForm } = props;

  const initValues = {
    CompanyID: { label: '', value: null },
    Message:
      'I am interested in being considered for career opportunities at your firm.',
  };

  const api = useApi();

  const handleQueryChange = (field, value, { setFieldValue }) => {
    setFieldValue(field, { label: value, value: null });
  };

  const handleSearchRequest = value =>
    new Promise(resolve => {
      api.get(
        ENDPOINT.FORM.OPTIONS.INBOUNDS_FIRMS,
        { query: value },
        {
          handleError: response => ResponseErrorDialog({ response }),
          handleSuccess: records => resolve(records),
        }
      );
    });

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames='fade'
    >
      <Formik
        initialValues={initValues}
        validationSchema={SendInboundsFormValidationSchema}
        onSubmit={onSaveForm}
      >
        {({
          values,
          errors,
          touched,
          dirty,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
        }) => (
          <form onSubmit={handleSubmit} className='send-inbounds-form'>
            {isSubmitting && <LoadMask relative />}
            <div className='send-inbounds-form__input'>
              <AsyncAutosuggest
                name='CompanyID'
                value={values.CompanyID.label}
                placeholder='Find Companies to InBound'
                onChange={(field, value) =>
                  handleQueryChange(field, value, { setFieldValue })
                }
                onSearchRequested={handleSearchRequest}
                onSelected={setFieldValue}
              />
              <button
                type='button'
                className='send-inbounds-form__btn'
                onClick={handleSubmit}
              />
            </div>
            <ErrorMessage
              name='CompanyID'
              render={message => <div className='form__error'>{message}</div>}
            />

            <div className='send-inbounds-form__message'>
              <BasicTextArea
                rows={8}
                name='Message'
                content={values.Message}
                resize={false}
                controlFunc={handleChange}
                isValid={
                  (!errors.Message && !!touched.Message) || !touched.Message
                }
                touchFunc={setFieldTouched}
              />
              <ErrorMessage
                name='Message'
                render={message => <div className='form__error'>{message}</div>}
              />
            </div>

            <BasicButton
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={600}
              btnText='Send Inbound'
              btnArrow={false}
              controlFunc={handleSubmit}
            />
          </form>
        )}
      </Formik>
    </CSSTransition>
  );
};

SendInboundsForm.propTypes = {
  onSaveForm: PropTypes.func.isRequired,
};

export default SendInboundsForm;
